// extracted by mini-css-extract-plugin
export var center = "Center-module--center--aeb4d";